import React from "react";
import { Box, Typography } from "@mui/material";
import useIsMobile from "./Hook/useIsMobile.js";
import PortfolioMobileView from "./pages/Portfolio/PortfolioMobileView.js";
import PortfolioPage from "./pages/Portfolio/PortfolioPage.js";


const ResponsivePortfolioComponent = () => {
  const isMobile = useIsMobile();

  return isMobile ? <PortfolioMobileView/> : <PortfolioPage />;
};

export default ResponsivePortfolioComponent;
